import Skeleton from '@carvana/ds-skeleton';

export default function BannerSkeleton() {
  return (
    <Skeleton
      className="mb-24 !h-[120px] !w-full !rounded-md sm:mb-32 sm:!h-[136px] md:!h-[176px] lg:!rounded-xl"
      data-testid="banner-skeleton"
    />
  );
}
